import { Flex, Icon, Text, TypeIconName, TypeSizes } from '@bitrise/bitkit';
import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

interface Props {
  gap?: TypeSizes;
  icon: TypeIconName;
  level: 'primary' | 'secondary';
  onClick: () => void;
}

const FiltersLabel: FunctionComponent<Props> = (props) => {
  const { children, gap, icon, level, ...rest } = props;
  const classes = classnames('Filters__label', `Filters__label--${level}`);

  return (
    <div {...rest} className={classes}>
      <Flex alignChildrenVertical="middle" direction="horizontal" gap={gap}>
        <Flex>
          <Icon name={icon} size="1rem" />
        </Flex>
        <Flex>
          <Text config="8" lineHeight="1">
            {children}
          </Text>
        </Flex>
      </Flex>
    </div>
  );
};

export default FiltersLabel;
